import { DAYS } from "@/data/days";

const DayCard = ({ d, index }) => {
  const flip = index % 2 === 1;
  return (
    <article
      data-testid={`day-card-${index}`}
      className="border-t border-[#D4CFC4]/70 pt-10 md:pt-14"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        {/* Image */}
        <div
          className={`lg:col-span-5 ${flip ? "lg:order-2" : "lg:order-1"}`}
        >
          <div
            data-testid={`day-image-${index}`}
            className="relative w-full overflow-hidden bg-[#F4F1EA]"
            style={{ aspectRatio: "4 / 5" }}
          >
            <img
              alt={d.imgAlt}
              className="w-full h-full object-cover"
              loading="lazy"
              src={d.img}
              style={{ objectPosition: "center center" }}
            />
          </div>
        </div>

        {/* Detail */}
        <div
          className={`lg:col-span-7 lg:pt-4 ${flip ? "lg:order-1" : "lg:order-2"}`}
          data-testid={`day-detail-${index}`}
        >
          <div className="flex items-center gap-4 mb-6">
            <span className="text-[10px] uppercase tracking-[0.35em] text-[#9E6D55] whitespace-nowrap">
              Day {d.day}
            </span>
            <span className="block h-px flex-1 bg-[#D4CFC4]" />
          </div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#9E6D55]/90 mb-4">
            {d.ribbonElement}
          </div>
          <h3 className="font-heading text-4xl md:text-5xl font-light leading-[1.05] text-[#2C3029]">
            {d.title}
          </h3>
          <p className="font-heading italic text-xl md:text-2xl text-[#9E6D55] mt-3">
            {d.chakra}
          </p>

          {d.richContent ? (
            <div className="mt-8 space-y-5">
              {d.richContent.map((item, idx) =>
                item.type === "italic" ? (
                  <p
                    key={idx}
                    className="font-heading italic text-lg md:text-xl font-light leading-snug text-[#9E6D55]"
                  >
                    {item.text}
                  </p>
                ) : (
                  <p
                    key={idx}
                    className="text-base md:text-lg font-light leading-relaxed text-[#5C6055]"
                  >
                    {item.text}
                  </p>
                ),
              )}
            </div>
          ) : (
            <>
              {d.body && (
                <p className="mt-8 text-base md:text-lg font-light leading-relaxed text-[#5C6055]">
                  {d.body}
                </p>
              )}

              {d.bullets && d.bullets.length > 0 && (
                <div className="mt-8">
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#9E6D55]/90 mb-4">
                    {d.bulletsLabel}
                  </div>
                  <ul className="space-y-3">
                    {d.bullets.map((b, i) => (
                      <li
                        key={i}
                        className="flex items-start gap-4 text-base md:text-lg font-light leading-relaxed text-[#5C6055]"
                      >
                        <span className="mt-[0.7em] block h-px w-5 flex-shrink-0 bg-[#9E6D55]/70" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {d.closing && (
                <p className="mt-8 text-base md:text-lg font-light italic leading-relaxed text-[#5C6055]">
                  {d.closing}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </article>
  );
};

const JourneySection = () => {
  return (
    <section
      id="journey"
      data-testid="itinerary-section"
      className="py-28 md:py-40 px-6 md:px-12 lg:px-24 bg-[#E8E4D9]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="block w-12 h-px bg-[#9E6D55]" />
            <span className="text-[10px] uppercase tracking-[0.35em] text-[#9E6D55]">
              A Glimpse of the Journey
            </span>
            <span className="block w-12 h-px bg-[#9E6D55]" />
          </div>
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl font-light tracking-tighter leading-[1] text-[#2C3029]">
            7 Nights to Soften.
            <br />
            <span className="italic">8 Days to Remember.</span>
          </h2>
        </div>

        <div className="space-y-20 md:space-y-28">
          {DAYS.map((d, i) => (
            <DayCard key={d.day} d={d} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default JourneySection;
